import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface EditProfileLayoutProps {
  title: ReactNode;
  children: ReactNode;
  onDiscard: () => void;
  onSave: () => void | Promise<void>;
  isSaving?: boolean;
  saveDisabled?: boolean;
}

const EditProfileLayout: React.FC<EditProfileLayoutProps> = ({
  title,
  children,
  onDiscard,
  onSave,
  isSaving = false,
  saveDisabled,
}) => {
  const handleSave = () => {
    void onSave();
  };
  const { t } = useTranslation();

  return (
    <section
      className={`flex h-full min-h-0 w-full flex-col rounded-xl bg-primary-bg p-4 md:p-5`}
    >
      <header className="mb-4 flex shrink-0 flex-wrap items-center justify-between gap-3">
        <h1 className="text-base font-bold text-primary-text">{title}</h1>

        <div className="flex items-center gap-2">
          <button
            type="button"
            disabled={isSaving}
            onClick={onDiscard}
            className="rounded-lg px-4 py-2 text-sm font-semibold text-primary-text transition-colors hover:bg-primary-click disabled:cursor-not-allowed disabled:opacity-50"
          >
            {t("cancel")}
          </button>

          <button
            type="button"
            disabled={isSaving || saveDisabled}
            onClick={handleSave}
            className="min-w-36 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primaryHovered disabled:cursor-not-allowed disabled:opacity-60"
          >
            {t("save_changes")}
          </button>
        </div>
      </header>

      <div
        className={`min-h-0 flex-1 overflow-y-auto rounded-xl bg-white p-4 md:p-8`}
      >
        <div className="mx-auto w-full max-w-[720px]">{children}</div>
      </div>
    </section>
  );
};

export default EditProfileLayout;
